module.exports = __webpack_public_path__ + "static/history-c0cd3082d583e22ce6e11069fa2844bd.jpg";